/** Legal pages chrome (/legal/:doc), the cookie consent banner and the TradingView consent gate (ADR-0048). The documents themselves: legal-docs/ (loaded with the legal page only). */
export default {
  updated: "Version 1.0 · in force from 31 October 2026",
  contents: "Contents",
  documents: "Legal documents",
  questions: "Questions about these documents: hello@fundedlime.com",
  nav: {
    terms: "Terms of Service",
    refunds: "Payments and refunds",
    payouts: "Payout policy",
    prohibited: "Prohibited practices",
    aml: "AML and KYC",
    privacy: "Privacy policy",
    cookies: "Cookie policy",
    risk: "Risk disclosure",
    execution: "Execution policy",
  },
  consent: {
    title: "Cookies",
    body: "We use only the cookies the site needs to work and stay secure. Optional ones (analytics, marketing, the TradingView chart) run only if you allow them.",
    policy: "Cookie policy",
    acceptAll: "Accept all",
    necessaryOnly: "Only necessary",
    settings: "Settings",
    save: "Save choice",
    close: "Close",
    open: "Cookie settings",
    always: "Always on",
    notUsed: "Not used today",
    necessary: { name: "Strictly necessary", note: "Sign-in, security, fraud prevention and remembering this choice. Cannot be switched off." },
    analytics: { name: "Analytics", note: "Visitor statistics to improve the site. We use none today; if we add them, they run only with this on." },
    marketing: { name: "Marketing", note: "Advertising and retargeting. We use none today; if we add them, they run only with this on." },
    external: { name: "External content", note: "The optional TradingView chart in the terminal. TradingView receives your IP address and may set its own cookies." },
  },
  tvGate: {
    title: "TradingView chart",
    body: "This view is loaded from TradingView, which receives your IP address and may set its own cookies.",
    load: "Load TradingView",
    policy: "Cookie policy",
  },
} as const;
